export const VITE_BACKEND_URL = import.meta.env.VITE_BACKEND_URL;
export const VITE_FRONTEND_URL = import.meta.env.VITE_FRONTEND_URL;
export const ASSETS_URL = import.meta.env.VITE_ASSETS_URL;
export const VITE_LAUNCH_DATE = import.meta.env.VITE_LAUNCH_DATE;
